import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../store';

export const selectSessionDomain = (state: RootState) => state.session;
export const selectSessionAuthError = createSelector(selectSessionDomain, (state) => state.authenticationError);
export const selectSessionUser = createSelector(selectSessionDomain, (state) => state.user);
